/* eslint-disable max-lines */
import Drawer from '@material-ui/core/Drawer/Drawer';
import ProductQuickView from 'components/Shared/ProductQuickView';
import { SvgIcon } from 'components/Shared/SvgIcon';
import { WithStyles } from 'decorators/withStyles';
import { IProductNew } from 'interfaces/product';
import { ITheme } from 'interfaces/theme';
import ApplicationExportIcon from 'mdi-react/ApplicationExportIcon';
import ArrowLeftBoldBoxIcon from 'mdi-react/ArrowLeftBoldBoxIcon';
import CartArrowUpIcon from 'mdi-react/CartArrowUpIcon';
import CartIcon from 'mdi-react/CartIcon';
import ChatAlertIcon from 'mdi-react/ChatAlertIcon';
import CommentEyeIcon from 'mdi-react/CommentEyeIcon';
import CreditCardCheckIcon from 'mdi-react/CreditCardCheckIcon';
import EmailIcon from 'mdi-react/EmailIcon';
import MonitorCellphone from 'mdi-react/MonitorCellphoneIcon';
import React, { Component } from 'react';
import * as rxjsOperators from 'rxjs-operators';
import { announcementService } from 'services/announcementService';
import authService from 'services/auth';
import { chatService } from 'services/chatService';
import { configService } from 'services/configService';
import { scriptElementsService } from 'services/elementsService';
import { exitPopUpService } from 'services/exitPopUpService';
import { productNewService } from 'services/productNewService';
import storageService from 'services/storage';
import { themeService } from 'services/themeService';
import { toastService } from 'services/toastService';
import { ENV } from 'settings';
import CardConfig from './Config';

interface IState {
  selectedProduct: IProductNew;
  viewedNewRelease: boolean;
  isClubeBlack?: boolean;
}

interface IProps {
  classes?: any;
}

@WithStyles(theme => ({
  '@keyframes toLeft': {
    from: {
      transform: 'translate(448px)'
    },
    to: {
      transform: 'translate(0)'
    }
  },
  drawerPaper: {
    transform: 'translate(448px)',
    animation: 'toLeft 0.3s ease-in-out 0.5s forwards',
    fontFamily: 'Lato',
    width: '448px',
    '@media screen and (max-width: 960px)': {
      width: '100%'
    }
  },
  drawerOptions: {
    overflow: 'scroll',
    backgroundColor: '#fff',
    height: '100%',
    padding: '1.25rem 1.5rem 9.375rem',
    width: '100%',
    '&::-webkit-scrollbar': {
      width: '6px',
      backgroundColor: '#F5F5F5'
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#555',
      borderRadius: 10
    }
  },
  titleClose: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  h2: {
    fontWeight: 'bold',
    color: theme.variables.colors['primaryColor'],
    margin: 0
  },
  card: {
    margin: '12px 0'
  },
  closeButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: '0px solid #000',
    borderRadius: '100%',
    width: 40,
    height: 40,
    color: '#596375',
    fontWeight: 'bold',
    backgroundColor: '#D8D8D8',
    cursor: 'pointer',
    alignSelf: 'flex-start',
    '&:hover': {
      backgroundColor: '#ccc'
    },
    '& svg': {
      width: '30%',
      fontWeight: 'bold',
      fill: '#596375'
    }
  },
  titleCard: {
    color: '#265AAB',
    fill: '#265AAB',
    '& p': {
      fontSize: '1.1em',
      marginLeft: 10,
      letterSpacing: '0.44px',
      fontWeight: 600,
      margin: 0
    }
  },
  description: {
    '& p': {
      color: '#78909C',
      letterSpacing: '0.44px',
      marginTop: 10,
      marginBottom: 5
    }
  },
  add: {
    '& a': {
      color: '#4CAF50',
      letterSpacing: '0.44px',
      margin: 0,
      cursor: 'pointer'
    }
  },
  link: {
    display: 'flex',
    alignItems: 'center'
  },
  notificationIcon: {
    fill: '#4CAF50',
    marginLeft: 6
  }
}))
export default class ProductActions extends Component<IProps, IState> {
  constructor(props: any) {
    super(props);
    this.state = { selectedProduct: null, viewedNewRelease: false, isClubeBlack: false };
  }

  componentDidMount() {
    productNewService
      .getSelectedProduct()
      .pipe(rxjsOperators.bindComponent(this))
      .subscribe(selectedProduct => {
        productNewService.setProductsWithoutSelected(selectedProduct);
        this.setState({ selectedProduct });
      });

    announcementService
      .getAnnouncement()
      .pipe(
        rxjsOperators.filter(announcement => !!announcement?.id),
        rxjsOperators.switchMap(announcement => storageService.get(announcement.id))
      )
      .subscribe(viewedNewRelease => this.setState({ viewedNewRelease: !viewedNewRelease }));

    authService.isClubeBlack().subscribe(isClubeBlack => {
      this.setState({ isClubeBlack });
    });
  }

  onClickElements = () => {
    const { selectedProduct } = this.state;
    if (ENV === 'production' && window?.hj) {
      window.hj('trigger', 'chk_elements');
      console.log('Trigger chk_elements');
    }
    scriptElementsService.setSelectedProduct(selectedProduct);
  };

  onClickChat = () => {
    const { selectedProduct } = this.state;
    chatService.setSelectedProductsChat(selectedProduct);
  };

  onClickToast = () => {
    const { selectedProduct } = this.state;
    toastService.setSelectedProduct(selectedProduct);
  };

  onClickPopUp = () => {
    const { selectedProduct } = this.state;
    exitPopUpService.setSelectedProduct(selectedProduct);
  };

  onClickConfig = () => {
    const { selectedProduct } = this.state;
    configService.showDrawer('upSell', selectedProduct);
  };

  onClickTheme = () => {
    const { selectedProduct } = this.state;
    const { loader, bindComponent, take } = rxjsOperators;

    if (ENV === 'production' && window?.hj) {
      window.hj('trigger', 'chk_customization');
      console.log('Trigger chk_customization');
    }

    themeService
      .loadThemes()
      .pipe(loader(), bindComponent(this))
      .subscribe();

    themeService
      .getThemes()
      .pipe(take(1), bindComponent(this))
      .subscribe((themes: ITheme[]) => {
        if (themes) {
          themes.map((theme: ITheme) => {
            if (theme.linkedProducts.includes(selectedProduct.id)) {
              themeService.setSelectedTheme(theme);
            }
          });
        }

        productNewService.setSelectedProduct({ ...selectedProduct });
      });
  };

  onClose = () => {
    productNewService.unselectProduct();
    toastService.unselectProduct();
  };

  onClickEmail = () => {
    const { selectedProduct } = this.state;
    configService.showDrawer('emailConfirmation', selectedProduct);
  };

  onClickInstallment = () => {
    const { selectedProduct } = this.state;
    configService.showDrawer('acceptMoreThan12Installments', selectedProduct);
  };

  onClickBackRedirect = () => {
    const { selectedProduct } = this.state;
    configService.showDrawer('backRedirect', selectedProduct);
  };

  render() {
    const { classes } = this.props;
    const { selectedProduct } = this.state;

    if (!selectedProduct) {
      return null;
    }
    const configs = [
      {
        title: 'Back Redirect',
        icon: <ArrowLeftBoldBoxIcon />,
        description:
          'Direcione a venda para outro produto se o comprador clicar no botão de voltar no navegador na página do checkout.',
        active: Boolean(selectedProduct?.config?.backRedirect?.active),
        callAction: this.onClickBackRedirect,
        show: true
      },
      {
        title: 'Checkout Elements',
        icon: <CartIcon />,
        description:
          'Conheça o novo Checkout embedado da Eduzz, adicione agora mesmo em sua página e aumente suas vendas.',
        callAction: this.onClickElements,
        show: selectedProduct.elements ?? false
      },
      {
        title: 'Tema',
        icon: <MonitorCellphone />,
        description:
          'Personalize o visual do seu Checkout de acordo com sua marca e produto, tendo assim mais diferencial no mercado',
        callAction: this.onClickTheme,
        active: selectedProduct.theme,
        show: true
      },
      {
        title: 'Chat',
        icon: <ChatAlertIcon />,
        description: 'Com o Chat sempre que houver dúvidas os clientes podem entrar em contato com você.',
        callAction: this.onClickChat,
        active: Boolean(selectedProduct.chat?.active),
        show: true
      },
      {
        title: 'Toast',
        icon: <CommentEyeIcon />,
        description:
          'Adicione um toast e informe quantas pessoas estão interessadas no seu produto, incentivando mais compradores.',
        callAction: this.onClickToast,
        active: Boolean(selectedProduct.toast?.active),
        show: true
      },
      {
        title: 'Exit Pop up',
        icon: <ApplicationExportIcon />,
        description:
          'Impeça compradores de sair da página de Checkout mostrando informações relevantes sobre seu produto.',
        callAction: this.onClickPopUp,
        active: Boolean(selectedProduct.exitPopUp?.active),
        show: true
      },
      {
        title: 'Página de obrigado para Upsell',
        icon: <CartArrowUpIcon />,
        description:
          'Melhore a experiência de compra de seus clientes removendo o pop-up da página de obrigado e aumente suas vendas de upsell',
        callAction: this.onClickConfig,
        active: selectedProduct?.config?.hasThankyouUpsell,
        show: true
      },
      {
        title: 'Confirmação de Email',
        icon: <EmailIcon />,
        description: 'Ative aqui a dupla confirmação de e-mail em seu checkout',
        active: selectedProduct?.config?.requestEmailConfirmation,
        callAction: this.onClickEmail,
        show: true
      },
      {
        title: 'Parcelamento em 18x',
        icon: <CreditCardCheckIcon />,
        description: 'Ative aqui o parcelamento 18x',
        active: selectedProduct?.config?.acceptMoreThan12Installments,
        callAction: this.onClickInstallment,
        show: false,
        onlyClubBlack: false,
        released: this.state.viewedNewRelease
      }
    ];

    return (
      <Drawer
        anchor="right"
        open={!!selectedProduct}
        PaperProps={{ classes: { root: classes.drawerPaper } }}
        transitionDuration={{ enter: 300, exit: 500 }}
        ModalProps={{
          classes: { root: classes.removeBackdrop },
          disableBackdropClick: true,
          onBackdropClick: this.onClose
        }}
      >
        <div className={classes.drawerOptions}>
          <div className={classes.titleClose}>
            <h2 className={classes.h2}>Personalização</h2>
            <span className={classes.closeButton} onClick={this.onClose}>
              <SvgIcon name="closeIcon" />
            </span>
          </div>
          <ProductQuickView />
          {configs.map(config => {
            if (!config.show) {
              return null;
            }
            if (config.onlyClubBlack && !this.state.isClubeBlack) {
              return null;
            }

            return <CardConfig key={config.title} {...config} />;
          })}
        </div>
      </Drawer>
    );
  }
}
